import { render, staticRenderFns } from "./RelojChecador.vue?vue&type=template&id=70a5a60c"
import script from "./RelojChecador.vue?vue&type=script&lang=js"
export * from "./RelojChecador.vue?vue&type=script&lang=js"
import style0 from "./RelojChecador.vue?vue&type=style&index=0&id=70a5a60c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports